export default "__VITE_ASSET__CY5TLAml__"